<template>
	<div>
  	<button class="uk-button uk-button-primary uk-border-rounded" @click="handleClick">
    	{{ text }}
  	</button>
	</div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: true
    }
  },
  methods: {
    handleClick() {
      // Emit a custom event to notify the parent component
      //this.$emit('click');
			console.log('click')
    }
  }
};
</script>

<style scoped>
.custom-button {
  /* Add your custom styles here */
}
</style>
